import * as React from 'react';
export const SvgAlarmPriority4 = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', ...props },
        React.createElement("circle", { cx: 8, cy: 8, fill: '#0ff', r: 6.5 }),
        React.createElement("path", { d: 'M8 2a6 6 0 11-6 6 6.007 6.007 0 016-6m0-1a7 7 0 107 7 7 7 0 00-7-7zm2.211 8.95h-.802v1.382H8.033V9.95H5.189v-.98l2.92-4.303h1.3v4.189h.802zM8.033 8.858v-1.13q0-.283.022-.82c.015-.359.028-.568.037-.625h-.037a5.121 5.121 0 01-.405.73L6.428 8.856z' })));
};
export default SvgAlarmPriority4;
